import React, { useState, useEffect } from "react";
import { useSnackbar } from "notistack";
import {
  resetPassword,
  updatePassword,
  verifyOtp,
  // updateUserProfile, // Optional if you plan to use
} from "../../util/AuthApiService";
import "./profile.css"; // Assuming you have a CSS file for styling

const ProfileContent = () => {
  const storedUser = JSON.parse(localStorage.getItem("users")) || {};
  const { enqueueSnackbar } = useSnackbar();

  const [username, setUsername] = useState(storedUser.username || "");
  const [otp, setOtp] = useState("");
  const [timer, setTimer] = useState(60);

  const [state, setState] = useState({
    isUpdatingPassword: false,
    isOtpSent: false,
    showUpdateForm: false,
  });

  const [passwords, setPasswords] = useState({
    newPassword: "",
    confirmPassword: "",
  });

  useEffect(() => {
    if (state.isOtpSent && timer > 0) {
      const interval = setInterval(() => setTimer((prev) => prev - 1), 1000);
      return () => clearInterval(interval);
    }
  }, [state.isOtpSent, timer]);

  const handlePasswordUpdate = () => {
    setState({ ...state, isUpdatingPassword: true, isOtpSent: true });
    setTimer(60);
    resetPassword({ email: storedUser.email }).catch((err) =>
      enqueueSnackbar(err?.response?.data || "Failed to send OTP")
    );
  };

  const handleResendOtp = () => {
    setOtp("");
    setTimer(60);
    setState({ ...state, showUpdateForm: false });
    resetPassword({ email: storedUser.email }).catch((err) =>
      enqueueSnackbar(err?.response?.data || "Resend OTP failed")
    );
  };

  const handleVerifyOtp = () => {
    verifyOtp({ email: storedUser.email, otp })
      .then(() => {
        enqueueSnackbar("OTP verified. You can now set a new password.");
        setState({ ...state, showUpdateForm: true });
      })
      .catch((err) => enqueueSnackbar(err?.response?.data || "Invalid OTP"));
  };

  const handleSubmitPassword = (e) => {
    e.preventDefault();
    const { newPassword, confirmPassword } = passwords;

    if (newPassword.trim() !== confirmPassword.trim()) {
      return enqueueSnackbar("Passwords do not match.");
    }

    updatePassword({ email: storedUser.email, password: newPassword.trim() })
      .then(() => {
        enqueueSnackbar("Password updated successfully!");
        handleCancel();
      })
      .catch((err) =>
        enqueueSnackbar(err?.response?.data || "Password update failed")
      );
  };

  const handleCancel = () => {
    setUsername(storedUser.username || "");
    setOtp("");
    setTimer(60);
    setPasswords({ newPassword: "", confirmPassword: "" });
    setState({
      isUpdatingPassword: false,
      isOtpSent: false,
      showUpdateForm: false,
    });
  };

  const handleSaveChanges = () => {
    const trimmedUsername = username.trim();
    if (trimmedUsername !== storedUser.username) {
      // updateUserProfile({ username: trimmedUsername }) // Add if you have an API
      enqueueSnackbar("Username updated successfully.");
    } else {
      enqueueSnackbar("No changes to save.");
    }
  };

  return (
    <div className="profile-content">
      <h2 className="content-title">Edit Your Profile</h2>
      <form className="profile-form" onSubmit={(e) => e.preventDefault()}>
        <div className="form-grid">
          <div className="form-group">
            <label>Email</label>
            <input type="email" value={storedUser.email} disabled />
          </div>
          <div className="form-group">
            <label>Subscription Type</label>
            <input type="text" value={storedUser.subscriptionType} disabled />
          </div>
          <div className="form-group">
            <label>Referral Code</label>
            <input type="text" value={storedUser.referral} disabled />
          </div>
          <div className="form-group">
            <label>Referred By</label>
            <input
              type="text"
              value={storedUser.referredBy || "N/A"}
              disabled
            />
          </div>
          <div className="form-group">
            <label>Username</label>
            <input
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
            />
          </div>
        </div>

        {!state.isUpdatingPassword ? (
          <div className="form-group">
            <button
              type="button"
              className="btn btn-save width-100"
              onClick={handlePasswordUpdate}
            >
              Update Password
            </button>
          </div>
        ) : (
          <div className="password-update-section">
            <h3 className="section-title">Enter OTP</h3>
            <div className="form-group">
              <input
                type="text"
                maxLength="6"
                placeholder="Enter OTP"
                value={otp}
                onChange={(e) => setOtp(e.target.value)}
              />
            </div>
            <div className="form-group">
              <button
                type="button"
                className="btn btn-save"
                onClick={handleVerifyOtp}
              >
                Verify OTP
              </button>
            </div>
            <p className="otp-timer">Resend OTP in {timer}s</p>

            {timer === 0 && !state.showUpdateForm && (
              <button
                type="button"
                className="btn btn-resend"
                onClick={handleResendOtp}
              >
                Resend OTP
              </button>
            )}

            {state.showUpdateForm && (
              <>
                <h3 className="section-title">Set New Password</h3>
                <div className="form-group">
                  <input
                    type="password"
                    placeholder="New Password"
                    value={passwords.newPassword}
                    onChange={(e) =>
                      setPasswords({
                        ...passwords,
                        newPassword: e.target.value,
                      })
                    }
                  />
                </div>
                <div className="form-group">
                  <input
                    type="password"
                    placeholder="Confirm New Password"
                    value={passwords.confirmPassword}
                    onChange={(e) =>
                      setPasswords({
                        ...passwords,
                        confirmPassword: e.target.value,
                      })
                    }
                  />
                </div>
                <button
                  type="submit"
                  className="btn btn-save"
                  onClick={handleSubmitPassword}
                >
                  Save Password
                </button>
              </>
            )}
          </div>
        )}

        <div className="form-actions">
          <button
            type="button"
            className="btn btn-cancel"
            onClick={handleCancel}
          >
            Cancel
          </button>
          <button
            type="button"
            className="btn btn-save"
            onClick={handleSaveChanges}
          >
            Save Changes
          </button>
        </div>
      </form>
    </div>
  );
};

export default ProfileContent;
